import { DEFAULT_CURRENCY } from '../../constants';
import { isCulinary, isHardGood } from '../../utils/product-utils';
import { PHOTO_FILES_LIMIT_SIZE } from './const';
import type { Orders } from '../../bff-api/orders/model/Order';
import type { Photo, TurnToOrderFeed } from './types';

const b64StringSize = (b64data: string): number => {
    const base64WithoutPrefix = b64data.split(',')[1] || b64data;
    const base64Length = base64WithoutPrefix.length;
    let padding = 0;
    if (base64WithoutPrefix.endsWith('==')) {
        padding = 2;
    } else if (base64WithoutPrefix.endsWith('=')) {
        padding = 1;
    }
    const fileSizeInBytes = (base64Length * 3) / 4 - padding;

    return fileSizeInBytes;
};

export const validateFilesSize = (files: Photo[]): boolean => {
    let isFilesSizeValid = true;
    files.forEach((file) => {
        if (file.b64data) {
            const fileB64DataSize = b64StringSize(file.b64data);
            if (fileB64DataSize > PHOTO_FILES_LIMIT_SIZE) {
                isFilesSizeValid = false;
            }
        }
    });

    return isFilesSizeValid;
};

export const buildTurnToOrderFeeds = (orders: Orders): TurnToOrderFeed[] =>
    orders
        .filter(({ c_gtmOrderPurchaseEventTriggered }) => !c_gtmOrderPurchaseEventTriggered)
        .map((order) => {
            const { currency = DEFAULT_CURRENCY, customerInfo, shipments = [] } = order;
            const firstName = customerInfo?.customerName?.split(' ')[0];
            const lastName = customerInfo?.customerName?.split(' ')[1];
            const items = order.productItems?.map((item) => ({
                title: item.productName,
                url: item.c_pwaUrl ? new URL(item.c_pwaUrl, window.location.href).href : undefined,
                itemImageUrl: item.c_imageUrl,
                sku: item.productId,
                qty: item.quantity,
                price: item.price,
            }));

            return {
                orderId: order.orderNo!,
                email: customerInfo?.email,
                postalCode: shipments[0]?.shippingAddress?.postalCode,
                firstName,
                lastName,
                total: order.orderTotal,
                currency,
                items,
            };
        });

export const shouldShowTurnToCommentCapture = (orders: Orders): boolean =>
    orders
        .filter(({ c_gtmOrderPurchaseEventTriggered }) => !c_gtmOrderPurchaseEventTriggered)
        .some(
            ({ productItems = [] }) =>
                productItems.some(isHardGood) || productItems.some(isCulinary),
        );
